import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { ErrorReportingService } from './error-reporting.service';

/**
 * Reporta falhas de transporte ao coletor de erros.
 *
 * Filtra de propósito: só status 0 (rede caiu/timeout) e 5xx (servidor) viram
 * evento. Os 4xx (validação, 401, etc.) são respostas esperadas e só
 * encheriam o coletor de ruído.
 */
@Injectable()
export class ErrorReportingInterceptor implements HttpInterceptor {
  constructor(private reporting: ErrorReportingService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const isTransportFailure = error.status === 0 || error.status >= 500;
        if (isTransportFailure) {
          this.reporting.captureException(error, {
            kind: 'http',
            method: request.method,
            url: request.urlWithParams,
            status: error.status,
          });
        }
        return throwError(() => error);
      }),
    );
  }
}
